import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { FulfilmentStatusEnum } from '../enums/fulfilment-status.enum';
import { FulfilmentStatusModel } from '../interfaces/fulfilment-status.interface';

export class FulfilmentStatusConstant {
  public static completed: FulfilmentStatusModel = {
    text: marker(`modules.evcSmallBiz.thankYou.fulfilment.completed.label`),
    status: FulfilmentStatusEnum.completed,
    colorCss: 'text-success-approved',
    icon: './assets/evc/img/checkmark-circle.svg',
  };
  public static progress: FulfilmentStatusModel = {
    text: marker('modules.evcSmallBiz.thankYou.fulfilment.progress.label'),
    status: FulfilmentStatusEnum.progress,
    colorCss: 'text-blue-dark',
    icon: './assets/evc/img/circle-outline-gradient.svg',
  };
  public static none: FulfilmentStatusModel = {
    text: '',
    status: FulfilmentStatusEnum.none,
    colorCss: '',
    icon: './assets/evc/img/circle-outline-gray.svg',
  };
  public static checkMailbox: FulfilmentStatusModel = {
    text: marker(`modules.evcSmallBiz.thankYou.fulfilment.checkMailbox.label`),
    status: FulfilmentStatusEnum.checkMailbox,
    colorCss: 'text-success-approved',
    icon: './assets/evc/img/checkmark-circle.svg',
  };
  public static optional: FulfilmentStatusModel = {
    text: marker('modules.evcSmallBiz.thankYou.fulfilment.optional.label'),
    status: FulfilmentStatusEnum.optional,
    colorCss: '',
    icon: './assets/evc/img/circle-outline-gray.svg',
  };
}
